import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle } from 'react-leaflet'; // Import du cercle
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'; // Assurez-vous que les styles de Leaflet sont importés

const GeolocationMap = () => {
  const [position, setPosition] = useState(null);

  useEffect(() => {
    // Vérification de la géolocalisation du navigateur
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setPosition({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          console.error(error);
          alert("Geolocation failed. Please allow location access.");
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }, []);

  // Si la position est non définie, afficher un message de chargement
  if (!position) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{ height: '500px' }}>
      <MapContainer center={[position.lat, position.lng]} zoom={13} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {/* Marqueur pour l'emplacement */}
        <Marker position={[position.lat, position.lng]}>
          <Popup>Votre position actuelle</Popup>
        </Marker>
        <Circle
          center={[position.lat, position.lng]} 
          radius={500} 
          color=" #FC7329"
          fillColor=" #FC7329"
          fillOpacity={0.4} 
        />
      </MapContainer>
    </div>
  );
};

export default GeolocationMap;
